// src/components/Contact.js
export default function Contact() {
  const IMG = process.env.PUBLIC_URL; // base path

  return (
    <footer
  id="contact"
  className="w-full overflow-hidden bg-slate-900 text-slate-100 py-16 px-4 sm:px-6"
>
      <div className="mx-auto max-w-5xl text-center">
        <h2 className="mb-8 text-3xl font-bold">Let’s connect</h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
          {/* email */}
          <a
            href="mailto:arjunvaish22@gmail.com"
            className="flex items-center gap-3 hover:text-purple-300"
          >
            <img src={`${IMG}/gmail.png`} alt="Gmail" className="h-6 w-6" />
            arjunvaish22@gmail.com
          </a>        
        </div>

        <p className="mt-10 text-xs text-slate-400">
          © {new Date().getFullYear()} Arjun Vaish
        </p>
      </div>
    </footer>
  );
}
